<template>
  <div class="img-dialog" v-show="value" :style="dialogStyle" @click="handleAction('confirm')"></div>
</template>
<script>
  import create from 'vant/lib/utils/create';
  import Popup from 'vant/lib/mixins/popup';

  export default create({
    name: 'ShareDialog',

    components: {},

    mixins: [Popup],

    props: {
      callback: Function,
      overlay: {
        type: Boolean,
        default: true
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: false
      },
      lockOnScroll: {
        type: Boolean,
        default: true
      },
      width: String,
      height: String,
      img: String,
    },
    methods: {
      handleAction(action) {
        this.$emit('input', false);
        this.$emit(action);
        this.callback && this.callback(action);
      }
    },
    computed: {
      dialogStyle(){
        let style = {};
        if (this.img && this.img.length > 0) {
          style = {
            background: "url(" + this.img + ") no-repeat",
            backgroundSize: 'cover'
          }
        }
        style.width = this.width;
        style.height = this.height;
        return style;
      }
    },
    mounted(){


    }
  });
</script>


<style lang="stylus" scoped>

  .img-dialog
    position: fixed;
    top: 0;
    right: 0;
    transition: .2s;


</style>



// WEBPACK FOOTER //
// src/components/Popups/ShareDialog/ShareDialog.vue